// extracted by mini-css-extract-plugin
export default {"cartsContainer":"CartItems_cartsContainer__a4oA+","head":"CartItems_head__6HVrl","cartContainerSkelleton":"CartItems_cartContainerSkelleton__3Zk1h"};